<template>
	<div>
		<b-row v-if="customerPaymentList.Name == 'Paytr'">
			<b-col lg="5" sm="12">
				<vs-card>
					<div slot="header">
						<h3 style="margin: 0px">
							{{ customerPaymentList.Name }} ile Öde
						</h3>
					</div>
					<b-row class="mb-2" v-if="ROLE != 'Company'">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Customer')" class="vs-input--label pr-0 mr-0" label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<v-select color="danger" v-model="customer" :options="customer_choices" size="small" label="CompanyName"
								v-on:input="
									getCompanyInformation();
								" autocomplete ref="selectElement">
							</v-select>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('UserName') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="userName" type="text" class="w-full" name="userName"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('userName')">{{
								errors.first("userName")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Email') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="email" type="text" class="w-full" name="email"
								v-validate="'required|email'" />
							<span class="text-danger text-sm" v-show="errors.has('email')">{{
								errors.first("email")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Address') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="address" type="text" class="w-full" name="address"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('address')">{{
								errors.first("address")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Phone') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="phone" type="text" class="w-full" name="phone"
								v-validate="'required|regex:^0\\d{10}$'" />
							<span class="text-danger text-sm" v-show="errors.has('phone')">{{
								errors.first("phone")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('PaymentNo') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="paymentNo" type="text" class="w-full" name="paymentNo"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('paymentNo')">{{
								errors.first("paymentNo")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col lg="4"> </b-col>
						<b-col>
							<b-button style="border-color: white; width: inherit" v-on:click="generateBarcode()" size="sm">
								{{ $t("Generate") }}
							</b-button>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('PaymentAmount') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="paymentAmount" type="text" class="w-full" name="paymentAmount"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('paymentAmount')">{{
								errors.first("paymentAmount")
							}}</span>
						</b-col>
					</b-row>

					<!--		
					
					////////////////////// LINKLE ODEMEDE KULLANILABİLİR
					
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('MaxInstallment') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="maxInstallment" type="text" class="w-full" name="maxInstallment"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('maxInstallment')">{{
								errors.first("maxInstallment")
							}}</span>
						</b-col>
					</b-row> 
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Currency') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="currency" type="text" class="w-full" name="currency" v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('currency')">{{
								errors.first("currency")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('PaymentAmount') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="paymentAmount" type="text" class="w-full" name="paymentAmount"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('paymentAmount')">{{
								errors.first("paymentAmount")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('UserName') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="userName" type="text" class="w-full" name="userName"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('userName')">{{
								errors.first("userName")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('LinkType') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="linkType" type="text" class="w-full" name="linkType"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('linkType')">{{
								errors.first("linkType")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('Lang') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="lang" type="text" class="w-full" name="lang"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('lang')">{{
								errors.first("lang")
							}}</span>
						</b-col>
					</b-row>
					<b-row class="mb-2">
						<b-col cols="4" align-self="center">
							<b-form-group :label="'* ' + $t('MinCount') + ': '" class="vs-input--label pr-0 mr-0"
								label-for="h-first-name">
							</b-form-group>
						</b-col>
						<b-col cols="8">
							<vs-input size="small" v-model="minCount" type="text" class="w-full" name="minCount"
								v-validate="'required'" />
							<span class="text-danger text-sm" v-show="errors.has('minCount')">{{
								errors.first("minCount")
							}}</span>
						</b-col>
					</b-row>-->
					<b-row class="mb-2">
						<b-col>
							<b-button style="border-color: white; width: inherit" v-on:click="generateIframeUrl()">
								{{ $t("Pay") }}
							</b-button>
						</b-col>
					</b-row>
				</vs-card>
			</b-col>
			<b-col v-if="paytr_token != ''">
				<iframe :src="'https://www.paytr.com/odeme/guvenli/' + paytr_token" id="paytriframe" frameborder="0"
					scrolling="yes" style="height: 1200px;width: 100%;"></iframe>
			</b-col>
		</b-row>


	</div>
</template>
<script>
import { mounted } from 'vue-barcode';
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { uuid } from "vue-uuid";
import moment from "moment";
export default {
	data() {
		return {
			ROLE: this.$store.state.AppActiveUser.ROLE,
			customer: "",
			customer_choices: [],
			maxInstallment: "12",
			currency: "TL",
			paymentAmount: "",
			paymentNo: "",
			userName: "",
			email: "",
			address: "",
			phone: "",
			linkType: "product",
			lang: "tr",
			minCount: "1",
			paytr_token: "",
			customerPaymentList: []
		}
	},
	components: {
		vSelect,
		uuid
	},
	methods: {
		generateBarcode() {
			let baseCode = this.generateRandomNumber(12);
			let checkDigit = this.calculateCheckDigit(baseCode);
			this.paymentNo = baseCode + checkDigit;
		},
		generateRandomNumber(length) {
			let result = "";
			result += Math.floor(Math.random() * 9) + 1;
			for (let i = 1; i < length; i++) {
				result += Math.floor(Math.random() * 10);
			}
			return result;
		},
		calculateCheckDigit(code) {
			let sum = 0;
			for (let i = 0; i < code.length; i++) {
				let num = parseInt(code[i]);
				sum += i % 2 === 0 ? num : num * 3;
			}
			let remainder = sum % 10;
			return remainder === 0 ? 0 : 10 - remainder;
		},
		getCompanyInformation() {
			this.userName = this.customer.CompanyName + " " + this.customer.CompanyName2;
			this.email = this.customer.Email;
			this.address = this.customer.Address1 + " " + this.customer.Address2 + " " + this.customer.Address3;
			this.phone = this.customer.Phone1;
		},
		parseDate(params) {
			return moment(String(params)).format("YYYY-MM-DD");
		},
		addPaymentTracking() {
			var createdId = uuid.v4();

			let args = {

				"paymentTrackingId": createdId,
				"companyId": this.customer.CompanyId,
				"orderNumber": this.paymentNo,
				"status": "Pending",
				"createdAt": this.parseDate(new Date(new Date().setDate(new Date().getDate()))),
				"notificationArrived": true,
				"notificationTime": this.parseDate(new Date(new Date().setDate(new Date().getDate()))),
				"totalAmount": this.paymentAmount,
				"statusMessage": "ödeme bekleniyor"
			};
			this.$store
				.dispatch("customer/addPaymentTracking", args)
				.then((response) => {
					if (response.status == 200) {
						vs.notify({
							text: response.data.message,
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "success",
							position: "top-center",
						});
					} else {
						vs.notify({
							text: response.data.message.toString(),
							iconPack: "feather",
							icon: "icon-alert-circle",
							color: "danger",
							position: "top-center",
						});
					}
				})
				.catch((error) => {
					return new Promise((resolve, reject) => {
						resolve(false);
					});
				});
		},
		generateIframeUrl() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					let args = {
						virtualPosId: this.customerPaymentList.VirtualPosId,
						Email: this.email,
						PaymentAmount: parseFloat(this.paymentAmount) * 100,
						UserName: this.userName,
						UserAddress: this.address,
						UserPhone: this.phone,
						MerchantOid: this.paymentNo
						//	Name: this.userName,
						//	Price: parseFloat(this.paymentAmount) * 100,
						//	Currency: this.currency,
						//	MaxInstallment: this.maxInstallment,
						//	LinkType: this.linkType,
						//	Lang: this.lang,
						//	MinCount: this.minCount

					}
					this.$store
						.dispatch("customer/generateLinkUrl", args)
						.then((response) => {
							console.log(response)
							if (response.status == 200) {
								this.paytr_token = response.data.json
								this.addPaymentTracking();
								//window.location.href = posReponse.link;
							} else console.log(response.statusText);

						});
				}
				else {
					vs.notify({
						text: this.$t("Validate"),
						iconPack: "feather",
						icon: "icon-alert-circle",
						color: "warning",
						position: "top-center",
					});
				}
			})

		},
		getPaymentMethod() {
			const vs = this.$vs;
			this.timelineData = [];
			this.$store
				.dispatch("customer/listCustomerUsingPayment")
				.then((response) => {
					if (response.success == true) {
						this.customerPaymentList = JSON.parse(response.json);
					} else console.log(response.statusText);

				});
		},

	},
	mounted() {
		if (window.iFrameResize) {
			window.iFrameResize({}, '#paytriframe');
		} else {
			console.warn("iFrameResize script not loaded.");
		}
		this.getPaymentMethod();
	},
	watch: {
		company(val) {
			this.customer_choices = val;
			return val;
		},
	},
	computed: {
		company: {
			get() {
				return this.$store.state.customer.Customer;
			},
			set(val) {
				if (!val) {
				}
			},
		},
	},
	created() {
		this.customer_choices = this.company;
		const dict = {
			custom: {
				paymentNo: {
					required: this.$t("paymentNoRequired"),
					alpha: this.$t("paymentNoRequired"),
				},
				paymentAmount: {
					required: this.$t("paymentAmountRequired"),
					alpha: this.$t("paymentAmountRequired"),
				},
				userName: {
					required: this.$t("userNameRequired"),
					alpha: this.$t("userNameRequired"),
				},
				email: {
					required: this.$t("emailRequired"),
					email: this.$t("emailInvalid")
				},
				address: {
					required: this.$t("addressRequired"),
					alpha: this.$t("addressRequired"),
				},
				phone: {
					required: this.$t("phoneRequired"),
					regex: this.$t("phoneInvalid"),
				}
			},
		};
		Validator.localize("en", dict);
	}
}
</script>